import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, tap, catchError } from 'rxjs';
import { AppErrorHandler } from './app-error.handler';
import { AppContext } from '../services/context/app.context.service';
import { CustomerContext } from '../services/context/customer.context.service';
import { v4 as uuidv4 } from 'uuid';
import { channel } from 'version';
@Injectable()
export class AppInterceptor implements HttpInterceptor {
  constructor(
    private readonly _cusCtxSvc: CustomerContext,
    private readonly _appCtxSvc: AppContext,
    private readonly _errorHandler: AppErrorHandler
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const country = (this._appCtxSvc.getUseAppContextCountry() ? this._appCtxSvc.getCountry() : this._cusCtxSvc.context?.country) || '';
    const localLanguage = this._appCtxSvc.getLanguage();
    const userType = this._appCtxSvc.getUserType();
    const traceId = this._appCtxSvc.getTraceSessionId();
    const email_agent = this._appCtxSvc.getUserAgentEmail();
    try {
      request = request.clone({
        headers: request.headers
          .set('Content-Type', 'application/json')
          .set('country', country)
          .set('Accept-Language', localLanguage.toLocaleLowerCase())
          .set('trace_id', uuidv4())
          .set('user-type', userType)
          .set('email_agent', email_agent)
          .set('monitoring_traceability_id', traceId)
          .set('channel', channel + '-' + userType),
      });

      return next.handle(request).pipe(
        tap((response: any) => {
          if (response instanceof HttpResponse) {
            // .... do whatever you want on good response...
          }

          return response;
        }),
        catchError(err => this._errorHandler.handleError(err))
      );
    } catch (error: any) {
      return this._errorHandler.handleError(error);
    }
  }
}
